import { render } from "./pu-prime-vietnam-reward.vue?vue&type=template&id=d0b97bfa"
import script from "./pu-prime-vietnam-reward.js?vue&type=script&lang=js&external"
export * from "./pu-prime-vietnam-reward.js?vue&type=script&lang=js&external"

import "./pu-prime-vietnam-reward.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__